import type { RegisteredVisual } from "view/dashboard/widgets/visuals/types";
import number from "view/dashboard/widgets/visuals/Number";
import text from "view/dashboard/widgets/visuals/Text";
export type * from "view/dashboard/widgets/visuals/types";

export const VISUALS = {
	NUMBER: number,
	TEXT: text,
} satisfies Record<string, RegisteredVisual>;

export type VisualId = keyof typeof VISUALS;
export type VisualRegistry = Record<VisualId, RegisteredVisual>;
